import { render } from "./PageNotFound.vue?vue&type=template&id=72a05b22&ts=true"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__